import { createPortal, useRef } from 'preact/compat'

export const SearchHeader = ({ query, totalResultsCount, isLoading, corrections }) => {
  const searchHeader = document.querySelector('#search-results')
  const content = useRef(searchHeader ? searchHeader.innerHTML : '')
  const hasMounted = useRef(false)

  if (!searchHeader) {
    return null
  }

  if (!hasMounted.current) {
    hasMounted.current = true
    searchHeader.innerHTML = ''
  }

  return createPortal(
    !isLoading && (
      <div className="flex flex-col md:justify-end gap-x-gutter gap-y-1 w-full" data-results={totalResultsCount}>
          <h2 className="h2 font-normal w-full">
              {totalResultsCount === 0 ? 'No' : `Showing ${totalResultsCount}`} Results For "{corrections?.corrected ? corrections?.corrected : query}"
          </h2>
        { totalResultsCount === 0 && (
          <div>
            <p className='paragraph-m font-bold pb-0'>Sorry, we couldn’t find what you were looking for.</p>
            <p className='paragraph-m'>Check your spelling, try another search or browse our popular products and collections below.</p>
          </div>
        )}
          {corrections?.corrected && (
              <div className="paragraph-s">
                  <p>No results found for "{query}". Showing results for "{corrections.corrected}" instead.</p>
              </div>
          )}
          {corrections?.didYouMean && (
              <div className="paragraph-s">
                  <p>Did you mean: <a href={`/search?query=${corrections.didYouMean}`} className='link-fade' aria-label={`Search for ${corrections.didYouMean}`}>{corrections.didYouMean}</a></p>
              </div>
          )}
          {totalResultsCount === 0 && !isLoading && (
              <div className={'[&>div]:!block'} dangerouslySetInnerHTML={{ __html: content.current }} />
          )}
      </div>
    ), searchHeader
  )
}
